import { professionNuancesA } from './nuancesA.js'
import { professionNuancesB } from './nuancesB.js'

// Editorial details tied to the workbook's stable provider IDs. These are
// illustrative planning context, never specialist product-feature promises.
export const professionNuances = Object.freeze({
  ...professionNuancesA,
  ...professionNuancesB,
})

export function getProfessionNuance(id) {
  return professionNuances[id] || null
}
